// extracted by mini-css-extract-plugin
module.exports = {"inputControls":"inputControls___amQvX"};